import {JsonAdapter} from "../helpers/JsonAdapter";
import {ToolkitChecklist} from "./ToolkitChecklist";

export class ToolkitStage {
  id: string = "";
  checklist: ToolkitChecklist[] = [];
  description: string = "";
  hint: string = "";
  stage: number = 0;
  title: number = 0;

  static create(object:any): ToolkitStage {
    const item = JsonAdapter.fill(new ToolkitStage(), object);

    if(object.checklist) {
      item.checklist = ToolkitChecklist.createMultiple(object.checklist);
    }

    return item;
  }

  static createMultiple(objects: ToolkitStage[]): ToolkitStage[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(ToolkitStage.create(objects[i]));
    }
    return items;
  }

  get icon() {
    switch(this.stage) {
      case 1: return 'faTelescope';
      case 2: return 'faRoute';
      case 3: return 'faPersonWalkingArrowRight';
      case 4: return 'faCertificate';
      default: return '';
    }
  }
}
